import type { IStringifyOptions } from 'qs'

export const SPANISH_SUBDIRECTORY = '/mexicopwa'
export const ENGLISH_SUBDIRECTORY = '/mexicoenglishpwa'

export const QS_CONFIG: IStringifyOptions = {
  arrayFormat: 'indices',
  encode: false,
}
